import { createMutation } from "../../utils/queryFactories.js";
import { api } from "../../utils/fetch.js";
import { z } from "zod";

const PatchChecklistItemResponseSchema = z.object({
  id: z.number(),
  status: z.union([z.literal(1), z.literal(2), z.literal(3)]),
  comment: z.string().nullable()
});

type PatchChecklistItem = z.infer<typeof PatchChecklistItemResponseSchema>;

const wfRequest = z.object({
  api: z.literal("wf"),
  id: z.number(),
  status: z.union([z.literal(1), z.literal(2), z.literal(3)]),
  comment: z.optional(z.string())
});
const publicRequest = z.object({
  api: z.literal("public"),
  id: z.number(),
  slug: z.string(),
  status: z.union([z.literal(1), z.literal(2), z.literal(3)]),
  comment: z.optional(z.string())
});

const PatchChecklistItemRequestSchema = z.discriminatedUnion("api", [
  wfRequest,
  publicRequest
]);

const PatchChecklistItemRequestVariables = z.union([
  wfRequest.omit({ api: true }),
  publicRequest.omit({ api: true })
]);

type PatchChecklistItemRequest = z.infer<
  typeof PatchChecklistItemRequestSchema
>;

const urls = {
  wf: `/checklist/item/:id`,
  public: `/public/:slug/checklist/item/:id`
};

export const useChecklistItemResponseSchema = createMutation<
  PatchChecklistItem,
  PatchChecklistItemRequest,
  Error
>({
  mutationFn: async (variables) => {
    const { api: checklistAPI, ...body } = variables;
    // await new Promise((resolve) => setTimeout(resolve, 10000));
    return api<Omit<PatchChecklistItemRequest, "api">, PatchChecklistItem>({
      method: "PATCH",
      url: urls[checklistAPI],
      requestSchema: PatchChecklistItemRequestVariables,
      responseSchema: PatchChecklistItemResponseSchema,
      body
    });
  }
});
